import { LoadingDirective, LoadingErrorComponent, LoadingPendingComponent, LoadingSpinnerComponent, LoadingEmptyComponent } from './loader.directive';
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/legacy-progress-spinner';
import { NgModule } from '@angular/core';
export enum LoadState {
  'loading' = 'loading',
  'error' = 'error',
  'completed' = 'completed',
  'pending' = 'pending',
  'empty' = 'empty'
}
@NgModule({
    declarations: [
        LoadingDirective,
        LoadingErrorComponent,
        LoadingSpinnerComponent,
        LoadingPendingComponent,
        LoadingEmptyComponent
    ],
    imports: [
        MatProgressSpinnerModule
    ],
    exports: [
        LoadingDirective
    ],
    providers: []
})
export class AnalyticsLoaderModule { }